export default "__VITE_ASSET__DrJyCN3m__"